import { z } from 'zod';

const customErrorMap: z.ZodErrorMap = (error, ctx) => {
  switch (error.code) {
    case z.ZodIssueCode.invalid_type:
      if (['undefined', 'null'].includes(error.received)) {
        return { message: 'To pole jest wymagane' };
      }
      break;
    case z.ZodIssueCode.invalid_string:
      if (error.validation === 'email') {
        return { message: 'Błędny adres email' };
      }
      break;
  }

  return { message: ctx.defaultError };
};

export const customizeZodErrorMap = () => z.setErrorMap(customErrorMap);
